export default __webpack_public_path__ + "static/media/duplicate.532bddd5.svg";